"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavContext = void 0;
var _react = _interopRequireWildcard(require("react"));
const NavContext = exports.NavContext = /*#__PURE__*/_react.default.createContext({});
const NavProvider = _ref => {
  let {
    children
  } = _ref;
  const [hoveredMenuItem, startHovering] = (0, _react.useState)();
  const [clickedMenuItem, setClickedItem] = (0, _react.useState)();
  const memoValue = (0, _react.useMemo)(() => ({
    itemSelected: clickedMenuItem || hoveredMenuItem,
    startHovering,
    setClickedItem
  }), [hoveredMenuItem, clickedMenuItem]);
  return /*#__PURE__*/_react.default.createElement(NavContext.Provider, {
    value: memoValue
  }, children);
};
var _default = exports.default = NavProvider;